import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Figures from "../../form/Figures";
import TypeTextEditor from "../../form/TypeTextEditor";
import CheckBox from "../../form/CheckBox";

class galleryForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="name" value={this.props.values.name} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor name="description" label="Leírás" data={this.props.values} componentConfig={this.props.componentConfig} getFieldProps={this.props.getFieldProps} setFieldValue={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="figures" label="Képek" componentConfig={this.props.componentConfig} data={this.props.values} />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <CheckBox {...this.props.getFieldProps("public")} name="public" value={this.props.values.public} label="Publikus" saveChanges={this.props.setFieldValue}/>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(galleryForm);
